import { render, staticRenderFns } from "./oneboxing.vue?vue&type=template&id=65633d1e&scoped=true"
import script from "./oneboxing.vue?vue&type=script&lang=js"
export * from "./oneboxing.vue?vue&type=script&lang=js"
import style0 from "./oneboxing.vue?vue&type=style&index=0&id=65633d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65633d1e",
  null
  
)

export default component.exports